module.exports = __webpack_public_path__ + "static/media/screenshot_2.4af4887f.png";